import { render, staticRenderFns } from "./basedInspection.vue?vue&type=template&id=06a1a4be&scoped=true&"
import script from "./basedInspection.vue?vue&type=script&lang=js&"
export * from "./basedInspection.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./basedInspection.vue?vue&type=style&index=1&id=06a1a4be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1a4be",
  null
  
)

export default component.exports